import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/OurValues.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'

class OurValues extends React.Component {

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, id } = this.props

    return (
      <section className={`${styles.section} ${styles.short}`}>
        <Container>
          <WhiteBlockTitle
            title={`Посмотрите <span>также</span>`}
            text={``}
            className={styles.title}
          />
          <div className={`${styles.keys} ${styles.keys2}`}>
              {data?.keys.map( ( elm, k ) => {
              if(id != elm?.id) return (
                <div key={k} className={`${elm.image != '' ? styles.kelm : styles.kelm_light}`}>
                  {elm.image != '' &&
                    <Image className={styles.kelm_image} src={elm.image} width={287} height={158} alt={elm?.name} />
                  }
                  <div className={styles.kelm_content}>
                    {elm?.rating != '' ?
                      <div className={styles.kelm_ratingline}>
                        <div className={styles.kelm_ratingline_left}>
                          <a className={styles.kelm_href} href={elm?.href}>
                            <GreenButton
                              text={`Смотреть`}
                              width={106}
                            />
                          </a>
                          <Image className={styles.kelm_rimage} src={elm.rimage} width={57} height={35} alt={elm?.name} />
                        </div>
                        <div className={styles.kelm_ratingline_sep}></div>
                        <div className={styles.kelm_rating}>
                          <div className={styles.kelm_rating_title}>
                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.5 0L7.95934 4.49139H12.6819L8.86126 7.26722L10.3206 11.7586L6.5 8.98278L2.6794 11.7586L4.13874 7.26722L0.318133 4.49139H5.04066L6.5 0Z" fill="#00C775"/>
                            </svg>
                            {elm?.rating}
                          </div>
                          <div>Рейтинг GW</div>
                        </div>
                      </div>
                    :
                      <>
                        {elm?.href != '' &&
                          <a className={styles.kelm_href} href={elm?.href}>
                            <GreenButton
                              text={`Смотреть`}
                              width={106}
                            />
                          </a>
                        }
                      </>
                    }
                    <div className={styles.kelm_title}>{elm?.name}</div>
                    <div className={styles.kelm_tline}>
                      <div>GOODWIN</div>
                      <div className={styles.kelm_sep}></div>
                      <div>{this.formatSlideNumber( k )}</div>
                    </div>
                  </div>
                </div>
              ) } )}
          </div>
        </Container>
      </section>
    )
  }
}

OurValues.propTypes = {
  data: PropTypes.object,
  id: PropTypes.number
}

OurValues.defaultProps = {
  data: {},
  id: 1
}

export default OurValues